import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { Checkbox, Column, TextField, useDevice } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import styles from './ExplicitApproval.module.scss';
const DEFAULT_STATEMENT = 'I have read and agree to the Terms of Service';
export const GetExplicitApprovalTID = (prefixTestId)=>getTestIds(prefixTestId);
export const ExplicitApproval = (param)=>{
    let { termsOfService, onTermsOfServiceChange, disabled, testId, error } = param;
    const { t: texts } = useLocaleKeys('components.agreementStudio.explicitApproval');
    const { ExplicitApprovalTID } = GetExplicitApprovalTID(testId);
    const { isMobileDevice } = useDevice();
    const isExplicitApprovalEnabled = (termsOfService === null || termsOfService === void 0 ? void 0 : termsOfService.type) === 'explicitApproval';
    const statement = isExplicitApprovalEnabled ? termsOfService === null || termsOfService === void 0 ? void 0 : termsOfService.explicitApproval.statement : undefined;
    const handleCheckboxChange = (e)=>{
        if (e.target.checked) {
            onTermsOfServiceChange({
                type: 'explicitApproval',
                explicitApproval: {
                    statement: DEFAULT_STATEMENT
                }
            });
        } else {
            onTermsOfServiceChange({
                type: 'none'
            });
        }
    };
    const handleStatementChange = (e)=>{
        onTermsOfServiceChange({
            type: 'explicitApproval',
            explicitApproval: {
                statement: e.target.value
            }
        });
    };
    const isDisabled = disabled || !termsOfService;
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 12,
        children: [
            /*#__PURE__*/ _jsx(Checkbox, {
                testId: ExplicitApprovalTID.Checkbox(),
                bi: {
                    name: 'explicit_approval_required'
                },
                checked: isExplicitApprovalEnabled,
                onChange: handleCheckboxChange,
                className: styles.checkboxExplicitApproval,
                disabled: isDisabled,
                label: texts.requireExplicitApproval(),
                labelInfo: texts.labelInfo()
            }),
            isExplicitApprovalEnabled && /*#__PURE__*/ _jsx(TextField, {
                className: cn(styles.statementInput, {
                    [styles.mobile]: isMobileDevice
                }),
                testId: ExplicitApprovalTID.StatementInput(),
                bi: {
                    name: 'explicit_approval_statement'
                },
                label: texts.checkboxStatement(),
                value: statement,
                onChange: handleStatementChange,
                disabled: disabled,
                error: !!error,
                helperText: error
            })
        ]
    });
};
